import { Attributes } from '@leverege/ui-attributes';
import PhoneValidator from "./PhoneValidator.js";
import EmailValidator from "./EmailValidator.js";
import AlphaNumericValidator from "./AlphaNumericValidator.js";
import RequiredValidator from "./RequiredValidator.js";
import VINValidator from "./VINValidator.js";
const builtIns = {
  email: EmailValidator,
  phone: PhoneValidator,
  alphanumeric: AlphaNumericValidator,
  required: RequiredValidator,
  vin: VINValidator
};
export default {
  processBlueprints(molten, blueprints) {
    blueprints.forEach(blueprint => {
      const attributes = Attributes.getAttributesFor(blueprint.type);
      attributes.forEach(attribute => {
        const validators = attribute.source?.attribute?.getTagsStartingWith('formValidator:', true);
        if (validators) {
          validators.forEach(validator => {
            if (builtIns[validator]) {
              builtIns[validator].createFor(attribute.name, attribute.objectType, {
                molten
              });
            }
          });
        }
        const isEmail = attribute?.source?.attribute?.hasTag('is:email');
        if (isEmail) {
          builtIns.email.createFor(attribute.name, attribute.objectType, {
            isArray: attribute.valueType?.endsWith('*'),
            molten
          });
        }
        const isPhone = attribute?.source?.attribute?.hasTag('is:phone');
        if (isPhone) {
          builtIns.phone.createFor(attribute.name, attribute.objectType, {
            isArray: attribute.valueType?.endsWith('*'),
            molten
          });
        }
      });
    });
  }
};